export default {
  name: 'product',
  components: {},
  data: function data() {
    return {
      isWeChatMiniProgram: false,
      // 是否在小程序环境
      source: "52haoma",
      isOnline: false,
      products: [],
      userAuth: null,
      platform: null
    };
  },
  computed: {},
  mounted: function mounted() {
    // console.log(source);
    this.source = this.$route.params.source ? this.$route.params.source : '52haoma';
    this.userAuth = this.$route.query.userAuth; // 初始化产品列表

    this.initProducts(); // 检测是否在微信小程序环境
    // eslint-disable-next-line no-undef

    this.isWeChatMiniProgram = typeof wx !== 'undefined' && wx.miniProgram;
  },
  methods: {
    pageUrl: function pageUrl(item) {
      if (item.h5Url.indexOf("txwk.10010.com") != -1) {
        return item.h5Url + "&commParam2=" + this.source;
      } else if (window.location.href.indexOf('/proxy/') != -1) {
        return item.h5Url + 'proxy/' + this.source;
      } else {
        return item.h5Url + this.source;
      }
    },
    initProducts: function initProducts() {
      var _this = this;

      var url = '/ad-server/mini-products/platflag-list?platFlag=h5';
      this.$axios.post(url).then(function (resp) {
        _this.products = resp.data.list;
      });
    },
    handleBackHome: function handleBackHome() {
      if (this.isWeChatMiniProgram) {
        // 小程序环境：发送消息给小程序
        // eslint-disable-next-line no-undef
        wx.miniProgram.postMessage({
          action: "goHome"
        });
      } else {// 普通浏览器环境：跳转到首页
        // window.location.href = "https://你的网站首页.com";
      }
    }
  }
};